import { createGlobalStyle } from "styled-components"

const GlobalStyles = createGlobalStyle`
  *, *:before, *:after {
    margin: 0;
    padding: 0;
    box-sizing: border-box !important;
  }

  html {
    color: #333;
    font-family: "Poppins", sans-serif;
    overscroll-behavior-x: none;
    overflow-x: hidden;
    scroll-behavior: smooth;
    scroll-padding-top: 100px;
    height: 100%;
    background: #fff;
    * {
      font-family: "Poppins", sans-serif;
    }
  }
  html, body {
    overscroll-behavior-y: none;
  }
  a {
    text-decoration: none;
  }
  /* Button reset */
  button {
    margin: 0;
    padding: 0;
    border: none;
    font-family: inherit;
    background-color: transparent;
    cursor: pointer;
  }
  input, textarea {
    border: none;
    outline: none;
    margin: 0;
    padding: 0;
  }
  /* Remove tap highlight */
  * {
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  }
  /* Handy utility */
  .pos-center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .pos-full {
    width: 100%;
    height: 100%;
  }

  /* Color tokens + nums */
  :root {
    --accent:  ${({ theme }) =>
      theme.color.accent}; /* really just for logo area when signed in */
    --content-pad: 1.5rem;
    --sparkle-red: #E43C4A;
    --sparkle-drkblue: #07234C;
    --sparkle-green: #06D6A0;
    --sparkle-drkgreen: #1EA380;
    --sparkle-brightblue: #2BB8E7;
    --sparkle-blue: #118AB2;
    --sparkle-ltblue: #E3EFF3;
    --sparkle-yellow: #FFDD66;
  }

  @media screen and (max-width: 700px) {
    :root {
    --content-pad: 10px;
    }
  }
`

export default GlobalStyles
